var map = {
	"./pin_black.png": 520,
	"./pin_blue.png": 521,
	"./pin_blue_bs.png": 522,
	"./pin_blue_bs_dot.png": 523,
	"./pin_brown.png": 524,
	"./pin_darkgrey.png": 525,
	"./pin_green.png": 526,
	"./pin_green_bs.png": 527,
	"./pin_grey.png": 528,
	"./pin_light_brown.png": 529,
	"./pin_lightblue.png": 530,
	"./pin_lightgreen.png": 531,
	"./pin_lightgrey.png": 532,
	"./pin_lightpurple.png": 533,
	"./pin_lightturquoise.png": 534,
	"./pin_orange.png": 535,
	"./pin_pastelblue.png": 536,
	"./pin_pink.png": 537,
	"./pin_purple.png": 538,
	"./pin_red.png": 539,
	"./pin_red_dot.png": 540,
	"./pin_turquoise.png": 541,
	"./pin_yellow.png": 542,
	"./position.png": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 519;